import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { CPFValidator } from './cpf.validator';
import { CNPJValidator } from './cnpj.validator';

export class CustomValidators {
  private static cpfValidator = new CPFValidator();
  private static cnpjValidator = new CNPJValidator();
  private static phoneValidator = new CNPJValidator();

  /**
   * Validador para CPF.
   */
  static cpf(message?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      return this.cpfValidator.isValid(value)
        ? null
        : { cpfInvalid: true, cpfInvalidMessage: message ?? 'CPF inválido' };
    };
  }

  /**
   * Validador para CNPJ.
   */
  static cnpj(message?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      return this.cnpjValidator.isValid(value)
        ? null
        : { cnpjInvalid: true, cnpjInvalidMessage: message ?? 'CNPJ inválido' };
    };
  }

  /**
   * Validador para CPF.
   */
  static phone(message?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      return this.phoneValidator.isValid(value)
        ? null
        : {
            phoneInvalid: true,
            phoneInvalidMessage: message ?? 'Telefone inválido',
          };
    };
  }

  static required(message?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const invalidated = Validators.required(control);
      return invalidated
        ? {
            ...invalidated,
            requiredMessage: message ?? 'Campo Obrigatório',
          }
        : null;
    };
  }

  static minLength(minLength: number, message?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const invalidated = Validators.minLength(minLength)(control);
      const isString = typeof control.value === 'string';
      const isArray = Array.isArray(control.value);

      return invalidated
        ? {
            ...invalidated,
            minLengthMessage:
              message ??
              `Obrigatório ao menos ${minLength} ${isString ? 'caracteres' : ''}${isArray ? 'items' : ''}`,
          }
        : null;
    };
  }

  static requiredTrue(message?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const invalidated = Validators.requiredTrue(control);

      return invalidated
        ? {
            ...invalidated,
            requiredTrueMessage: message ?? 'Campo obrigatório',
          }
        : null;
    };
  }

  static dateTimeRequired(
    message = 'Data e hora são obrigatórias',
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value || !value.date || !value.time) {
        return {
          dateTimeRequired: true,
          dateTimeRequiredMessage: message,
        };
      }
      return null;
    };
  }

  static requiredIfOtherHasValue(
    otherControlName: string,
    message = 'Campo obrigatório ao marcar a opção acima.',
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.parent) {
        return null;
      }

      const otherControl = control.parent.get(otherControlName);
      if (otherControl && otherControl.value) {
        return control.value
          ? null
          : { fieldValueRequired: true, fieldValueMessage: message };
      }

      return null;
    };
  }
}
